/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1740441600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Feb 25 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "google",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Google Ads",
          "depth": 0,
          "id": "connect-to-google-ads"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Select account",
          "depth": 1,
          "id": "select-account"
        }, {
          "value": "Syncing customer match user lists",
          "depth": 1,
          "id": "syncing-customer-match-user-lists"
        }, {
          "value": "Syncing conversion events",
          "depth": 1,
          "id": "syncing-conversion-events"
        }, {
          "value": "Syncing click conversions",
          "depth": 1,
          "id": "syncing-click-conversions"
        }, {
          "value": "Syncing click conversion adjustments",
          "depth": 1,
          "id": "syncing-click-conversion-adjustments"
        }, {
          "value": "Syncing call conversions",
          "depth": 1,
          "id": "syncing-call-conversions"
        }, {
          "value": "Syncing offline store conversions",
          "depth": 1,
          "id": "syncing-offline-store-conversions"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Matched users count",
          "depth": 1,
          "id": "matched-users-count"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      h3: "h3",
      img: "img",
      h4: "h4",
      ul: "ul",
      li: "li",
      code: "code",
      ol: "ol"
    }, _provideComponents(), props.components), {MatchBoosterDestination, EventSyncWarning, MatchRatesExplanation, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!MatchBoosterDestination) _missingMdxReference("MatchBoosterDestination", true);
    if (!MatchRatesExplanation) _missingMdxReference("MatchRatesExplanation", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Customer Match User List"
              })
            }), _jsx(_components.td, {
              children: "Creates a customer list for the Customer Match feature of Google Ads. Segments are automatically created in Google Ads based on the name of the model"
            }), _jsx(_components.td, {
              children: "Add, Update, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/google-ads/api/docs/remarketing/audience-types/customer-match",
                children: "Customer Match User List"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Click Conversions"
              })
            }), _jsx(_components.td, {
              children: "Sends click conversion tracking information to Google Ads for each record in the query results"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/google-ads/api/docs/conversions/upload-clicks",
                children: "Click Conversions"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Click Conversion Adjustments"
              })
            }), _jsx(_components.td, {
              children: "Sends click conversion adjustments to Google Ads for each record in the query results"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/google-ads/api/docs/conversions/upload-adjustments",
                children: "Click Conversion Adjustments"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Call Conversions"
              })
            }), _jsx(_components.td, {
              children: "Sends call conversion tracking information to Google Ads for each record in the query results"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/google-ads/api/docs/conversions/upload-calls",
                children: "Call Conversions"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Offline Store Conversions"
              })
            }), _jsx(_components.td, {
              children: "Sends offline store sales conversion tracking information to Google Ads for each record in the query results"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/google-ads/api/docs/conversions/upload-store-sales-transactions",
                children: "Offline Store Conversions"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsxs(_components.p, {
        children: ["API version in use: ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/reference/rpc/v16/overview",
          children: "v16"
        })]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-google-ads",
        children: "Connect to Google Ads"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button.\nSelect ", _jsx(_components.strong, {
          children: "Google Ads"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Google Ads"
        }), " via OAuth."]
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Log in to Google Ads"
        }), ", log in with your Google Account, and click ", _jsx(_components.strong, {
          children: "Allow"
        }), ".\nYou should then see a success notification in the Hightouch UI."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Google Ads destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data.\nGo to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin.\nThen, select the relevant model and the Google Ads destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "select-account",
        children: "Select account"
      }), "\n", _jsxs(_components.p, {
        children: ["To begin, select the account you want to sync data to.\nIf an account appears at the top level, it means you have direct access to that ad account or ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/7459399",
          children: "manager account"
        }), ".\nHightouch accesses nested accounts via the root account that you have direct access to."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-select-account.png",
          alt: "Select Google Ads account"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["In the preceding example screenshot, the authenticated account has direct access to the ", _jsx(_components.strong, {
          children: "Hightouch"
        }), " (5138398925) ad account and the ", _jsx(_components.strong, {
          children: "Hightouch Manager Account"
        }), " (5277198417).\nThe authenticated account also has access to the manager account's three nested accounts, including the Hightouch (5138398925) ad account."]
      }), "\n", _jsx(_components.p, {
        children: "Selecting either account at the top level syncs directly to those accounts without logging in via another manager account.\nSelecting a nested account requires Hightouch to login via the root manager account."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-customer-match-user-lists",
        children: "Syncing customer match user lists"
      }), "\n", _jsxs(_components.p, {
        children: ["Google's ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/10550383",
          children: "Customer Match"
        }), " tool lets you use the online and offline data your customers have shared with you to deliver targeted ads."]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you create and maintain customer match lists via the Google Ads API.\nIt can take 6 to 48 hours for a list to be populated with members once Hightouch has sent the data to Google.\nYou can find more information about this on the API reference page linked in the ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "supported syncing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "user-list-type",
        children: "User list type"
      }), "\n", _jsxs(_components.p, {
        children: ["To begin, select the ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/reference/rpc/v13/CustomerMatchUploadKeyTypeEnum.CustomerMatchUploadKeyType",
          children: "upload key type"
        }), " for the customer match list.\nIt can be one of these values:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "CONTACT_INFO"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "MOBILE_ADVERTISING_ID"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "CRM_ID"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-user-list-type.png",
          alt: "Selecting user list type"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Choose the type that aligns with the data fields you are sending.\nFor example, if you are sending email or address data, select ", _jsx(_components.strong, {
          children: "CONTACT_INFO"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-list-or-create-a-new-one",
        children: "Select an existing list or create a new one"
      }), "\n", _jsxs(_components.p, {
        children: ["You can create a new ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/6276125",
          children: "Customer match user list"
        }), " or use an existing one.\nWhen creating a new list, you can optionally enter a name.\nOtherwise, Hightouch defaults to the name of the associated model."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-new-user-list.png",
          alt: "New user list"
        })
      }), "\n", _jsx(_components.p, {
        children: "To use an existing list, select the desired list from the dropdown."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-existing-user-list.png",
          alt: "Existing user list"
        })
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["If you choose to create a new list, you can't update the\n", _jsx(_components.a, {
            href: "#select-account",
            children: "account"
          }), " to which you're syncing data after the initial sync\nrun. If you need to change the account, configure a new sync."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Optionally, you can also set the ", _jsx(_components.strong, {
          children: "membership lifespan"
        }), " for the list.\nThe value must be between 0 and 540. If you do not set this value, the default value is 540."]
      }), "\n", _jsxs(_components.p, {
        children: ["Starting April 7th, 2025, the maximum membership duration for a Google Ads customer list is ", _jsx(_components.strong, {
          children: "540 days"
        }), ".\nFrom this date, existing lists configured to have no membership expiration set or membership expiration greater than 540 days will be updated to use the maximum membership duration of 540 days, and a membership duration of 540 days will be retroactively applied to all those existing members that have a longer duration.\nSee ", _jsx(_components.a, {
          href: "https://ads-developers.googleblog.com/2025/02/update-to-customer-match-membership.html",
          children: "Google's announcement"
        }), " for more information."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-membership-lifespan.png",
          alt: "User list membership lifespan"
        })
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "To identify which users to add or update in an audience, select model columns and the corresponding Google Ads fields.\nYou must map at least one identifier."
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "Google Ads customer match lists"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-customer-match.png",
          alt: "Customer match user lists field mapping"
        })
      }), "\n", _jsx(_components.h4, {
        id: "handling-pii-and-hashing",
        children: "Handling PII and hashing"
      }), "\n", _jsxs(_components.p, {
        children: ["You can enable PII hashing if you wish for Hightouch to detect whether your data requires normalization and hashing based on the chosen record mapping.\nFor example, if you select ", _jsx(_components.strong, {
          children: "Email"
        }), " and the model column with the email data is unhashed, Hightouch hashes the value for you."]
      }), "\n", _jsx(_components.p, {
        children: "By default, Hightouch automatically detects if the following fields require hashing:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Email"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Phone"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "First Name"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Last Name"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-pii.png",
          alt: "PII hashing"
        })
      }), "\n", _jsx(_components.h4, {
        id: "cleaning-your-data",
        children: "Cleaning your data"
      }), "\n", _jsxs(_components.p, {
        children: ["Optionally, you can decide if Hightouch should clean your phone numbers and remove ", _jsx(_components.code, {
          children: "null"
        }), " or incorrectly formatted values from your data."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-phone-numbers-remove-fields.png",
          alt: "Clean phone numbers and remove null or incorrectly formatted fields"
        })
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results.\nYou have the following options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the record in the audience"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Remove record"
              })
            }), _jsx(_components.td, {
              children: "Remove the Google Ads record from the specified audience"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are uploading data for users in the European Economic Area (", _jsx(_components.a, {
          href: "https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Economic_Area_(EEA)",
          children: "EEA"
        }), "),\nyou need to ensure you are passing the required consent signals to ", _jsx(_components.a, {
          href: "https://www.google.com/about/company/user-consent-policy/?sjid=2196795394224792925-NA",
          children: "Google"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "For each sync, you can specify the consent status for these types:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "ad_user_data"
          }), ": consent for sending user data to Google for advertising purposes"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "ad_personalization"
          }), ": consent for ad personalization"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Check out Google's support ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/14310715?hl=en",
          children: "doc"
        }), " to learn more."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-conversion-events",
        children: "Syncing conversion events"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports syncing the following conversion events:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.a, {
            href: "#syncing-click-conversions",
            children: "Click conversions"
          }), " and ", _jsx(_components.a, {
            href: "#offline-click-conversions",
            children: "Offline click conversions"
          })]
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#syncing-click-conversion-adjustments",
            children: "Click conversion adjustments"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#syncing-call-conversions",
            children: "Call conversions"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#syncing-offline-store-conversions",
            children: "Offline store conversions"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing conversion events, Hightouch treats any records added to ", _jsx(_components.a, {
          href: "/getting-started/concepts",
          children: "your source"
        }), " as new events and sends them to Google Ads when your sync runs."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "custom-conversion-variables",
        children: "Custom conversion variables"
      }), "\n", _jsxs(_components.p, {
        children: ["You can ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "map"
        }), " custom variables when syncing conversion events to Google Ads.\nFirst, you need to set up ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/9962082",
          children: "custom conversion variables"
        }), " in Google. Custom conversion variables are only available for the following:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Conversion tracking using ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/6331314",
            children: "tags on your website"
          }), ", if you're syncing ", _jsx(_components.a, {
            href: "#syncing-click-conversions",
            children: "click conversions"
          }), " or ", _jsx(_components.a, {
            href: "#syncing-call-conversions",
            children: "call conversions"
          })]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/2998031",
            children: "Offline conversion import"
          }), ", if you're syncing ", _jsx(_components.a, {
            href: "#syncing-offline-click-conversions",
            children: "offline click conversions"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["You can read more about this in ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/9964350",
          children: "Google Ads Help"
        }), " and also in ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/docs/conversions/conversion-custom-variables",
          children: "Google Ads' API documentation"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "currency-codes",
        children: "Currency codes"
      }), "\n", _jsxs(_components.p, {
        children: ["Google requires all conversion events to include a currency code in a separate column in addition to the amount.\nThis applies to ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "click conversions"
        }), ", ", _jsx(_components.a, {
          href: "#syncing-click-conversion-adjustments",
          children: "click conversion adjustments"
        }), ", and ", _jsx(_components.a, {
          href: "#syncing-offline-store-conversions",
          children: "offline store conversions"
        }), ".\nConsult Google's chart of ", _jsx(_components.a, {
          href: "https://developers.google.com/adsense/management/appendix/currencies",
          children: "supported currency codes"
        }), " to ensure your data meets their specifications."]
      }), "\n", _jsx(_components.h4, {
        id: "enhanced-conversions",
        children: "Enhanced conversions"
      }), "\n", _jsxs(_components.p, {
        children: ["You can sync both types of ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/9888656",
          children: _jsx(_components.strong, {
            children: "Enhanced conversions"
          })
        }), " to Google Ads using Hightouch:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/9888656#leads",
            children: _jsx(_components.strong, {
              children: "Enhanced conversions for leads"
            })
          }), ": set up an ", _jsx(_components.a, {
            href: "#offline-click-conversions",
            children: "Offline click conversion"
          }), " in Google Ads; then select ", _jsx(_components.strong, {
            children: "Click Conversions"
          }), " as the ", _jsx(_components.a, {
            href: "#supported-syncing",
            children: "sync type"
          }), " and ", _jsx(_components.a, {
            href: "#user-identifiers-1",
            children: "set up your field mappings"
          }), " accordingly"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/13261987",
            children: _jsx(_components.strong, {
              children: "Enhanced conversions for web"
            })
          }), ": select ", _jsx(_components.a, {
            href: "#syncing-click-conversion-adjustments",
            children: "Click Conversion Adjustments"
          }), " as the ", _jsx(_components.a, {
            href: "#supported-syncing",
            children: "sync type"
          }), " and ", _jsx(_components.strong, {
            children: "Enhancement"
          }), " as the ", _jsx(_components.a, {
            href: "#select-conversion-action-and-adjustment-type",
            children: "adjustment type"
          })]
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy-1",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are uploading data for users in the European Economic Area (", _jsx(_components.a, {
          href: "https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Economic_Area_(EEA)",
          children: "EEA"
        }), "),\nyou need to ensure you are passing the required consent signals to ", _jsx(_components.a, {
          href: "https://www.google.com/about/company/user-consent-policy/?sjid=2196795394224792925-NA",
          children: "Google"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["For ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "click conversions"
        }), ", ", _jsx(_components.a, {
          href: "#syncing-call-conversions",
          children: "call conversions"
        }), " and ", _jsx(_components.a, {
          href: "#syncing-offline-store-conversions",
          children: "offline store conversions"
        }), ", you can specify the Google consent status for advertising purposes, by mapping these fields in the sync configuration:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "Ad user data consent"
          }), " (for the ", _jsx(_components.code, {
            children: "ad_user_data"
          }), " property)"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "Ad personalization consent"
          }), " (for the ", _jsx(_components.code, {
            children: "ad_personalization"
          }), " property)"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["As per ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/reference/rpc/v17/Consent",
          children: "Google's API documentation"
        }), ", these fields only accept the following values:  ", _jsx(_components.code, {
          children: "​GRANTED​"
        }), ", ", _jsx(_components.code, {
          children: "​DENIED​"
        }), ", ", _jsx(_components.code, {
          children: "UNSPECIFIED"
        }), "​, ​", _jsx(_components.code, {
          children: "UNKNOWN"
        }), "​."]
      }), "\n", _jsxs(_components.p, {
        children: ["Check out Google's support ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/14310715?hl=en",
          children: "doc"
        }), " to learn more."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-click-conversions",
        children: "Syncing click conversions"
      }), "\n", _jsxs(_components.p, {
        children: ["Google Ads allows you to ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/12216424",
          children: "import conversions from ad clicks"
        }), " to see how your online ads are performing.\nBefore setting up your sync, you need to ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/12216226",
          children: "set up a conversion action"
        }), " in Google Ads."]
      }), "\n", _jsxs(_components.p, {
        children: ["After clicking ", _jsx(_components.strong, {
          children: "New conversion action"
        }), ", remember to select ", _jsx(_components.strong, {
          children: "Website"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-conversion-action.png",
          alt: "Setting up conversion action"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["It can take over 24 hours for click conversions to be processed by Google.\nYou can find more information about this and other requirements on the API reference page linked in the ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "supported syncing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "offline-click-conversions",
        children: "Offline click conversions"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Offline click conversions"
          }), " are not ", _jsx(_components.a, {
            href: "#syncing-offline-store-conversions",
            children: "offline store\nconversions"
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can sync ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/2998031",
          children: "offline click conversion imports"
        }), " which allow you to measure what happens in the offline world after an ad results in a click or call to your business.\nFor these events, you need to ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/7012522",
          children: "set up offline conversion imports"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["After clicking ", _jsx(_components.strong, {
          children: "New conversion action"
        }), ", remember to select ", _jsx(_components.strong, {
          children: "Import"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-conversion-action.png",
          alt: "Setting up conversion action"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Then select ", _jsx(_components.strong, {
          children: "CRMs, files, or other data sources"
        }), " and ", _jsx(_components.strong, {
          children: "Track conversions from clicks"
        }), " and continue the offline conversion import setup. You can safely skip setting up a data source."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-import-offline-conversions.png",
          alt: "Import offline conversions"
        })
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["Check out our ", _jsx(_components.a, {
            href: "https://hightouch.com/blog/google-offline-conversions",
            children: "blog\npost"
          }), " and\n", _jsx(_components.a, {
            href: "https://hightouch.com/playbooks/automate-offline-conversion-uploads-to-maximize-roas",
            children: "playbook"
          }), "\nto learn how to sync ", _jsx(_components.strong, {
            children: "offline click conversions"
          }), " to Google Ads."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "select-conversion-action",
        children: "Select conversion action"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "conversion action"
        }), " you previously set up in your Google Ads account.\nThe dropdown menu displays the conversion action IDs present in your Google Ads account."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-select-conversion-action.png",
          alt: "Select conversion action"
        })
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers-1",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "Select which columns to sync from your source to Google Ads' fields. When syncing click conversions, at least one identifier is required:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "GCLID"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "GBRAID"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "WBRAID"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "User hashed email(s)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "User hashed phone(s)"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Furthermore, ", _jsx(_components.strong, {
          children: "Conversion time"
        }), " is a mandatory field."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-click-conversion-field-mapping.png",
          alt: "Click conversion field mapping"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can send ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/9888656#leads",
          children: "enhancements as click conversions"
        }), " by mapping the ", _jsx(_components.strong, {
          children: "User hashed email(s)"
        }), " and ", _jsx(_components.strong, {
          children: "User hashed phone(s)"
        }), " fields instead of ", _jsx(_components.strong, {
          children: "GCLID"
        }), ".\nThe ", _jsx(_components.a, {
          href: "/models/data-types-casting",
          children: "model columns"
        }), " mapped to these fields can contain either single values or arrays.\nRead through Google Ads' ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/docs/conversions/upload-identifiers",
          children: "API documentation"
        }), " for more details."]
      }), "\n", _jsxs(_components.p, {
        children: ["If you opt to send user emails and/or phone numbers instead of ", _jsx(_components.strong, {
          children: "GCLID"
        }), ", keep in mind that each click conversion can only have up to five user identifiers in total.\nFor example, a click conversion can have three emails and two phone numbers, or any combination that adds up to five."]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["These enhancements are also referred to as ", _jsx(_components.strong, {
            children: "Enhanced conversions for leads"
          }), ".\nThey are not ", _jsx(_components.strong, {
            children: "Enhanced conversions for web"
          }), ", which are described in the\n", _jsx(_components.a, {
            href: "#select-conversion-action-and-adjustment-type",
            children: "Syncing click conversion\nadjustments"
          }), " section."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Avoid storing your ", _jsx(_components.strong, {
          children: "GCLID"
        }), ", ", _jsx(_components.strong, {
          children: "GBRAID"
        }), ", and ", _jsx(_components.strong, {
          children: "WBRAID"
        }), " data in the same model column since this can cause issues when syncing your data.\n", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/docs/conversions/upload-clicks#id_parameters",
          children: "Google Ads' limitations"
        }), " determine which values can and cannot be synced together.\nIf this data is in the same model column and you try mapping this column to multiple Google Ads fields (such as ", _jsx(_components.strong, {
          children: "GCLID"
        }), " and ", _jsx(_components.strong, {
          children: "WBRAID"
        }), "), you might receive a ", _jsx(_components.code, {
          children: "VALUE_MUST_BE_UNSET"
        }), " or ", _jsx(_components.code, {
          children: "GBRAID_WBRAID_BOTH_SET"
        }), " error.\nCheck out the ", _jsx(_components.a, {
          href: "#common-errors",
          children: "common errors"
        }), " section to learn more about these errors."]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["If a model row contains a ", _jsx(_components.code, {
            children: "null"
          }), " value in a model column mapped to the\n", _jsx(_components.strong, {
            children: "GCLID"
          }), ", ", _jsx(_components.strong, {
            children: "GBRAID"
          }), ", or ", _jsx(_components.strong, {
            children: "WBRAID"
          }), " fields, Hightouch ignores that value when\nsyncing the row Google Ads. This process helps reduce\n", _jsx(_components.a, {
            href: "#value_must_be_unset",
            children: _jsx(_components.code, {
              children: "VALUE_MUST_BE_UNSET"
            })
          }), " or\n", _jsx(_components.a, {
            href: "#gbraid_wbraid_both_set",
            children: _jsx(_components.code, {
              children: "GBRAID_WBRAID_BOTH_SET"
            })
          }), " errors."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy-2",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["Learn more about the EU consent policy ", _jsx(_components.a, {
          href: "#eu-user-consent-policy-1",
          children: "in this section"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-click-conversion-adjustments",
        children: "Syncing click conversion adjustments"
      }), "\n", _jsxs(_components.p, {
        children: ["After sending a click conversion to Google Ads, you can ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/7686447",
          children: "adjust the conversion"
        }), " later by sending a click conversion adjustment.\nWait at least 24 hours after a click conversion is reported to Google Ads before adjusting it to avoid a ", _jsx(_components.code, {
          children: "CONVERSION_NOT_FOUND"
        }), " or ", _jsx(_components.code, {
          children: "TOO_RECENT_CONVERSION"
        }), " error.\nYou can find more information about this on the API reference page linked in the ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "supported syncing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "select-conversion-action-and-adjustment-type",
        children: "Select conversion action and adjustment type"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "conversion action"
        }), " you previously set up in your Google Ads account.\nThe dropdown menu displays the conversion action IDs present in your Google Ads account."]
      }), "\n", _jsx(_components.p, {
        children: "You also need to select the adjustment type. You can choose from:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/7686447",
            children: "Retraction"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/7686447",
            children: "Restatement"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/13261987",
            children: "Enhancement"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-select-conversion-action-adjustment.png",
          alt: "Select conversion action and adjustment type"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Enhancements are also referred to as ", _jsx(_components.strong, {
            children: "Enhanced conversions for web"
          }), ". They\nare not ", _jsx(_components.strong, {
            children: "Enhanced conversions for leads"
          }), ", which are described in the\n", _jsx(_components.a, {
            href: "#user-identifiers-1",
            children: "Syncing click conversions"
          }), " section."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you select the ", _jsx(_components.strong, {
          children: "Enhancement"
        }), " adjustment type, you need to select if this is a first party or third party data upload."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-first-third-party-data-1.png",
          alt: "First or third party data upload"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Select which columns to sync from your source to Google Ads' fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "GCLID"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Conversion time"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Adjustment time"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Order ID"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["If you select the ", _jsx(_components.strong, {
          children: "Retraction"
        }), " adjustment type, you can only map those fields."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-adjustment-retraction.png",
          alt: "Retraction field mapping"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you select the ", _jsx(_components.strong, {
          children: "Restatement"
        }), " adjustment type, you can map those four fields plus:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Restatement value"
          }), ", which is mandatory"]
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Restatement currency"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-adjustment-restatement.png",
          alt: "Restatement field mapping"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you select the ", _jsx(_components.strong, {
          children: "Enhancement"
        }), " adjustment type, you can map those four fields plus:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Enhancement User Agent"
          })
        }), "\n", _jsxs(_components.li, {
          children: ["various hashed fields: ", _jsx(_components.strong, {
            children: "Email"
          }), ", ", _jsx(_components.strong, {
            children: "Phone"
          }), ", ", _jsx(_components.strong, {
            children: "First Name"
          }), ", ", _jsx(_components.strong, {
            children: "Last Name"
          }), ", ", _jsx(_components.strong, {
            children: "Street Address"
          })]
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Country"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Postal Code"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "State"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "City"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-adjustment-enhancement.png",
          alt: "Enhancement field mapping"
        })
      }), "\n", _jsx(_components.h4, {
        id: "handling-pii-and-hashing-1",
        children: "Handling PII and hashing"
      }), "\n", _jsxs(_components.p, {
        children: ["You can find more information about this in the ", _jsx(_components.a, {
          href: "#handling-pii-and-hashing",
          children: "PII and hashing"
        }), " section."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-call-conversions",
        children: "Syncing call conversions"
      }), "\n", _jsxs(_components.p, {
        children: ["Google Ads allows you to import phone call conversions to keep track of how your calls impact your ad campaigns.\nAfter setting up ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/6275629",
          children: "phone call conversions"
        }), ", you can use Hightouch to sync your data to Google Ads.\nYou can find more information about this on the API reference page linked in the ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "supported syncing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "select-conversion-action-1",
        children: "Select conversion action"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "conversion action"
        }), " you previously set up in your Google Ads account.\nThe dropdown menu displays the conversion action IDs present in your Google Ads account."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-select-conversion-action.png",
          alt: "Select conversion action"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Select which columns to sync from your source to Google Ads' fields.\n", _jsx(_components.strong, {
          children: "Conversion time"
        }), ", ", _jsx(_components.strong, {
          children: "Caller ID"
        }), ", and ", _jsx(_components.strong, {
          children: "Call start time"
        }), " are mandatory fields."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-call-conversions.png",
          alt: "Call conversion field mapping"
        })
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy-3",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["Learn more about the EU consent policy ", _jsx(_components.a, {
          href: "#eu-user-consent-policy-1",
          children: "in this section"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-offline-store-conversions",
        children: "Syncing offline store conversions"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Offline store conversions"
          }), " are not ", _jsx(_components.a, {
            href: "#offline-click-conversions",
            children: "offline click\nconversions"
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Google Ads offers enhanced store sales measurement and reporting data to better optimize your online ads.\nAfter setting up ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/9995886",
          children: "offline store sales conversions"
        }), ", you can use Hightouch to sync your data to Google Ads.\nYou can find more information about this on the API reference page linked in the ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "supported syncing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "select-conversion-action-2",
        children: "Select conversion action"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "conversion action"
        }), " you previously set up in your Google Ads account.\nThe dropdown menu displays the conversion action IDs present in your Google Ads account."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-select-conversion-action.png",
          alt: "Select conversion action"
        })
      }), "\n", _jsx(_components.h4, {
        id: "optional-settings",
        children: "Optional settings"
      }), "\n", _jsx(_components.p, {
        children: "You can decide if you would like to include the following information:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "custom key"
          }), ", to segment store sales conversions"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "loyalty fraction"
          }), ", which is a decimal value that sets the percentage of overall sales that can be associated with a customer"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "transaction upload fraction"
          }), ", which is a decimal value that sets the percentage of overall sales with customer information that are already uploaded to Google Ads"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-offline-store-conversions-optional.png",
          alt: "Offline store conversions optional settings"
        })
      }), "\n", _jsx(_components.h4, {
        id: "first-or-third-party-data",
        children: "First or third party data"
      }), "\n", _jsx(_components.p, {
        children: "You need to select if this is a first party or third party data upload."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-first-third-party-data-2.png",
          alt: "First or third party data upload"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Select which columns to sync from your source to Google Ads' fields.\n", _jsx(_components.strong, {
          children: "Transaction time"
        }), " and ", _jsx(_components.strong, {
          children: "Transaction amount (micros)"
        }), " are mandatory fields."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-google-ads-field-mapping-offline-store-conversions.png",
          alt: "Offline store conversions field mapping"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Any transaction amount here should be in the unit ", _jsx(_components.strong, {
            children: "micros"
          }), ". For example,\n$200 = 200000000."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy-4",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["Learn more about the EU consent policy ", _jsx(_components.a, {
          href: "#eu-user-consent-policy-1",
          children: "in this section"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "handling-pii-and-hashing-2",
        children: "Handling PII and hashing"
      }), "\n", _jsxs(_components.p, {
        children: ["You can find more information about this in the ", _jsx(_components.a, {
          href: "#handling-pii-and-hashing",
          children: "PII and hashing"
        }), " section."]
      }), "\n", _jsx(_components.h4, {
        id: "cleaning-your-data-1",
        children: "Cleaning your data"
      }), "\n", _jsxs(_components.p, {
        children: ["You can find more information about this in the ", _jsx(_components.a, {
          href: "#cleaning-your-data",
          children: "Cleaning your data"
        }), " section."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "matched-users-count",
        children: "Matched users count"
      }), "\n", _jsx(_components.p, {
        children: "Below only applies to the customer match user list sync type."
      }), "\n", _jsx(MatchRatesExplanation, {
        destination: "Google Ads"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Google Ads contain a few different matched users count in their platform.\nHightouch refers to the ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/117120?ctx=glossary&sjid=7733029462129080931-NA",
            children: "display network\nsize"
          }), "\nand the ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/90956?ctx=glossary&sjid=7733029462129080931-NA",
            children: "search network\nsize"
          }), ".\nIf the display network size is available, that is used in our app, else the\nsearch network size is used. Google Ads also have a concept of a match rate\nbut this is different than what Hightouch is calculating, which is the % of\ntargetable users from your model in this GoogleAds audience. Per Google, ”Your\nCustomer Match match rate is the percentage of your uploaded customer list\nthat could be connected to Google users, so you can see how much of your list\nis usable. Keep in mind that your match rate is not an indicator of how your\nlists will perform, but rather an indicator of whether you're uploading the\nright data in the right way”\n(", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/10534785?hl=en",
            children: "reference"
          }), ")."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "at-least-one-click-identifier-gclid-gbraid-or-wbraid-is-required",
        children: "At least one click identifier ('gclid', 'gbraid' or 'wbraid') is required"
      }), "\n", _jsxs(_components.p, {
        children: ["Make sure that you mapped at least one identifier when syncing ", _jsx(_components.a, {
          href: "#field-mapping",
          children: "Click conversions"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "conversion_precedes_event",
        children: "CONVERSION_PRECEDES_EVENT"
      }), "\n", _jsxs(_components.p, {
        children: ["As described in ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/reference/rpc/v13/ConversionUploadErrorEnum.ConversionUploadError#conversion_precedes_event",
          children: "Google Ads' documentation"
        }), ", this error occurs if the imported event has a ", _jsx(_components.code, {
          children: "conversion_date_time"
        }), " that precedes the click.\nTo avoid this error, make sure that the timestamps in your source data and your Google Ads account have the same timezone configured."]
      }), "\n", _jsx(_components.h4, {
        id: "expired_event",
        children: "EXPIRED_EVENT"
      }), "\n", _jsxs(_components.p, {
        children: ["As explained in ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/reference/rpc/v13/ConversionUploadErrorEnum.ConversionUploadError#expired_event",
          children: "Google Ads' documentation"
        }), ", this error happens when a ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "click conversion"
        }), " can't be accepted since its click occurred before this conversion's ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/3123169",
          children: "click-through window"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "gbraid_wbraid_both_set",
        children: "GBRAID_WBRAID_BOTH_SET"
      }), "\n", _jsxs(_components.p, {
        children: ["This error happens if you sync data both to the ", _jsx(_components.strong, {
          children: "GBRAID"
        }), " and ", _jsx(_components.strong, {
          children: "WBRAID"
        }), " fields.\nYou can read more about this in ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/docs/conversions/upload-clicks",
          children: "Google Ads' API documentation"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "incompatible_upload_key_type",
        children: "INCOMPATIBLE_UPLOAD_KEY_TYPE"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing Customer Match user lists, make sure to select the correct ", _jsx(_components.a, {
          href: "#user-list-type",
          children: "user list type"
        }), ". If you selected the wrong type when setting up your sync, create a new sync with the correct type."]
      }), "\n", _jsx(_components.h4, {
        id: "invalid_conversion_action",
        children: "INVALID_CONVERSION_ACTION"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing Click conversions, ensure that you've chosen the correct conversion type within the Google Ads UI.\nFor normal ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "Click conversions"
        }), ", choose the ", _jsx(_components.strong, {
          children: "Website"
        }), " type. For ", _jsx(_components.a, {
          href: "#offline-click-conversions",
          children: "Offline click conversions"
        }), ", choose the ", _jsx(_components.strong, {
          children: "Import"
        }), " type."]
      }), "\n", _jsx(_components.p, {
        children: "Furthermore, make sure that:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["your data satisfies the requirements outlined in ", _jsx(_components.a, {
            href: "https://developers.google.com/google-ads/api/docs/conversions/upload-clicks#upload_clickconversion",
            children: "this section"
          }), " of Google Ads' API documentation"]
        }), "\n", _jsxs(_components.li, {
          children: ["you selected the correct ", _jsx(_components.a, {
            href: "#select-account",
            children: "Google Ads account"
          }), " in your sync configuration"]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Make sure to not confuse ", _jsx(_components.a, {
            href: "#offline-click-conversions",
            children: "Offline click\nconversions"
          }), " with ", _jsx(_components.a, {
            href: "#syncing-offline-store-conversions",
            children: "Offline store\nconversions"
          }), "."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "invalid_customer_id",
        children: "INVALID_CUSTOMER_ID"
      }), "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "400 - {\"error\":{\"code\":400,\"message\":\"Request contains an invalid argument.\"...\"message\":\"Invalid customer ID...}"
        }), " error message because you are attempting to sync to a Google account that is different from the initial sync."]
      }), "\n", _jsxs(_components.p, {
        children: ["If there has been a successful initial sync with sync configurations of ", _jsx(_components.code, {
          children: "Customer Match User List"
        }), " and ", _jsx(_components.code, {
          children: "Create a new user list"
        }), ", changing the Google account will result in sync failure on the next run. You can resolve the error by either:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Selecting the original Google account that was used on the initial sync"
        }), "\n", _jsx(_components.li, {
          children: "Creating a new sync and selecting the new Google Account"
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "invalid_grant",
        children: "INVALID_GRANT"
      }), "\n", _jsx(_components.p, {
        children: "The token for the user that connected the Google Ads destination has expired or revoked. Please re-auth within the destination settings."
      }), "\n", _jsx(_components.h4, {
        id: "no-error-message-provided",
        children: "No error message provided"
      }), "\n", _jsxs(_components.p, {
        children: ["This error can happen if you ", _jsx(_components.a, {
          href: "/syncs/mapping-data#model-column-changes",
          children: "rename a model column"
        }), " after adding it as a field mapping in your sync configuration.\nTo resolve this, update your field mappings to contain the updated model column names."]
      }), "\n", _jsx(_components.h4, {
        id: "required_field_missing",
        children: "REQUIRED_FIELD_MISSING"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "#record-matching",
          children: "Customer Match User Lists"
        }), " require at least one personal identifier. Check the required fields relevant for the match list type you've chosen."]
      }), "\n", _jsx(_components.h4, {
        id: "unauthorized_customer",
        children: "UNAUTHORIZED_CUSTOMER"
      }), "\n", _jsxs(_components.p, {
        children: ["This can happen when you try syncing a ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "click conversion"
        }), " to Google Ads that is associated with a different ad account. If you wish to sync click conversions from different ad accounts without needing to use separate syncs, you can set up a manager account and enable ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/3030657",
          children: "cross-account conversion tracking"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "value_must_be_unset",
        children: "VALUE_MUST_BE_UNSET"
      }), "\n", _jsx(_components.p, {
        children: "This error happens if you:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["sync data to the ", _jsx(_components.strong, {
            children: "GCLID"
          }), " field and also to the ", _jsx(_components.strong, {
            children: "GBRAID"
          }), " or ", _jsx(_components.strong, {
            children: "WBRAID"
          }), " fields"]
        }), "\n", _jsxs(_components.li, {
          children: ["sync data to ", _jsx(_components.a, {
            href: "#custom-conversion-variables",
            children: "custom conversion variables"
          }), " and also to the ", _jsx(_components.strong, {
            children: "GBRAID"
          }), " or ", _jsx(_components.strong, {
            children: "WBRAID"
          }), " fields"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["You can read more about this in ", _jsx(_components.a, {
          href: "https://developers.google.com/google-ads/api/docs/conversions/upload-clicks",
          children: "Google Ads' API documentation"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
